<template>
  <v-container
    id="Productos"
    grid-list-xl
    class="mx-auto testimonios"
    :class="[
      { 'mt-4': $vuetify.breakpoint.smAndDown },
      { 'mt-6': $vuetify.breakpoint.mdAndUp },
    ]"
    style="max-width: 1340px"
  >
    <v-layout row wrap>
      <v-flex
        xs12
        sm6
        md4
        lg4
        xl4
        class="mx-auto ma-4"
        v-for="(item, index) in Testimonios_itemsNew"
        :key="index"
      >
        <v-card outlined max-width="550" min-height="100">
        <div
                class="person-card"
                style="background-color: transparent"
              >
          <v-card-text>
           <div style="width: 100%; height: 100%">
                               <v-card width="125" class="mx-auto mt-n16 text-center">
                    <v-img
                      :src="`${imgTestimonios}${item.person_img}`"
                      class="person_img"
                    ></v-img>
                  </v-card>
           </div>
   
         
            <div class="subtitle-1 text-center font-weight-bold pt-5">
              {{ item.person_name }}</div
            >

            <p class="subtitle-1 text-center mt-2">
              {{ item.testimonio }}
            </p>
          
        
 <v-img
          
          class="mysty"
              :src="`${imgTestimonios}${item.empre_img}`"
              contain
              height="50"
            ></v-img>

         
          </v-card-text>    
        </div>
        
          
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "TestimoniosCli",
  created() {
      window.scrollTo(0, 0);
    this.initialize();
    this.clr_Testimonios_items();
  },
  data() {
    return {
      length: 5,
      window: 0,
    };
  },
  computed: {
    ...mapState(["imgTestimonios", "Testimonios_items", "dirPHP"]),
    Testimonios_itemsNew() {
      if (this.Testimonios_items) {
        let nb = this.Testimonios_items.filter((x) => x.activo === true);
        return nb;
      }
    },
  },
  methods: {
    ...mapMutations(["set_Testimonios_items", "clr_Testimonios_items"]),
    async initialize() {
      let that = this;
      const URL = `${this.dirPHP}leertestimonio.php`;
      await this.axios
        .get(URL, {
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          response.data.forEach(function (data, index) {
            that.set_Testimonios_items(data);
          });
        });
    },
  },
};
</script>
<style scoped>
.person_img {
  border-style: solid;
  border-width: 1px;
  border-color: #fe5000; /*#002f6c*/
}
.person-card {
  border-style: solid;
  min-height: 440px;
  border-width: 2px;
  border-color: #fe5000; /*#002f6c*/
}
.testimonios {
  padding-top: 25px;
  padding-bottom: 30px;
  /*#fe5000*/
}
.mysty {
  position: absolute;

left: 0;
right: 0;
bottom: 0;
margin: auto;
    bottom:5px;
    right:10px;
} 
</style>
